import React from 'react';
import { GiFairyWings } from 'react-icons/gi';
import { Helmet } from "react-helmet-async";
import './Privacy.css';

const Privacy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Rajput Shiksha Kosh</title>
        <meta
          name="description"
          content="Privacy policy for Rajput Shiksha Kosh, outlining how we collect, use, and protect your personal information."
        />
      </Helmet>
    <section className="privacy-policy-wrapper">
      <div className="privacy-policy-container">
        
        {/* --- 1. HEADER (Title + Divider) --- */}
        <div className="privacy-policy-header">
          <h2 className="privacy-policy-title">PRIVACY POLICY</h2>
          <div className="privacy-policy-divider">
            <span className="privacy-policy-line"></span>
            <GiFairyWings className="privacy-policy-icon" />
            <span className="privacy-policy-line"></span>
          </div>
        </div>

        {/* --- 2. MAIN CONTENT DIV (White Background Card) --- */}
        <div className="privacy-policy-content-card">
          
          <h3 className="privacy-policy-sub-heading-line">
            राजपूत शिक्षा कोष - गोपनीयता नीति
          </h3>
          
          <p className="privacy-policy-paragraph">
            <strong>राजपूत शिक्षा कोष</strong> में, हम अपने दानदाताओं, विद्यार्थियों और वेबसाइट पर आने वाले सभी लोगों की व्यक्तिगत जानकारी की सुरक्षा के लिए पूरी तरह प्रतिबद्ध हैं। एक सार्वजनिक धर्मार्थ ट्रस्ट के रूप में, हमारे कार्य के मूल सिद्धांत <strong>पूर्ण पारदर्शिता और समाज के विश्वास</strong> पर आधारित हैं। यह गोपनीयता नीति (Privacy Policy) स्पष्ट करती है कि अभावग्रस्त और प्रतिभावान छात्रों को शिक्षा प्रदान करने के हमारे मिशन के तहत, हम आपकी जानकारी कैसे एकत्र, उपयोग और साझा करते हैं।
          </p>

          <h4 className="privacy-policy-section-title">1. हम कौनसी जानकारी एकत्र करते हैं</h4>
          <p className="privacy-policy-paragraph">
            हम मुख्य रूप से दान प्राप्त करने, छात्रवृत्ति आवेदनों का मूल्यांकन करने और <em>राजपूत प्रतिभा खोज परीक्षा</em> जैसे शैक्षणिक कार्यक्रमों के आयोजन के लिए जानकारी एकत्र करते हैं। इस डेटा में शामिल हैं:
          </p>
          <ul className="privacy-policy-list">
            <li><strong>दानदाताओं की जानकारी:</strong> नाम, संपर्क नंबर (Contact No.), ईमेल आईडी, लेन-देन का विवरण और दान का प्रकार (जैसे- सामान्य दान, शिक्षा नेक, प्रोत्साहन निधि)।</li>
            <li><strong>विद्यार्थियों की जानकारी:</strong> छात्रवृत्ति मूल्यांकन के लिए आवश्यक विवरण जैसे- छात्र का नाम, पिता का नाम, पता, वर्तमान कक्षा, परीक्षा के अंक और आर्थिक स्थिति।</li>
            <li><strong>वित्तीय डेटा:</strong> सुरक्षित पेमेंट गेटवे विवरण (हम आपके क्रेडिट/डेबिट कार्ड के नंबर या बैंक पासवर्ड अपने सर्वर पर स्टोर नहीं करते हैं)।</li>
          </ul>

          <h4 className="privacy-policy-section-title">2. पारदर्शिता और सार्वजनिक प्रकटीकरण (महत्वपूर्ण)</h4>
          <p className="privacy-policy-paragraph">
            एकत्रित की गई धनराशि का उपयोग कैसे किया जा रहा है, इसमें 100% पारदर्शिता सुनिश्चित करने और समाज का अटूट विश्वास बनाए रखने के लिए, <strong>हम अपनी वेबसाइट पर कुछ विशिष्ट रिकॉर्ड सार्वजनिक रूप से प्रदर्शित करते हैं</strong>। हमारे ट्रस्ट से जुड़ने का अर्थ है कि आप निम्नलिखित बातों से सहमत हैं:
          </p>
          <ul className="privacy-policy-list">
            <li><strong>सार्वजनिक दानदाता सूची (Public Donor's List):</strong> हम अपने दानदाताओं के नाम, संपर्क नंबर, दान का प्रकार, भुगतान का माध्यम और दान की गई राशि को वेबसाइट पर सार्वजनिक करते हैं। इससे हर दानदाता को यह विश्वास होता है कि उनका योगदान सुरक्षित रूप से प्राप्त और दर्ज कर लिया गया है।</li>
            <li><strong>सार्वजनिक छात्रवृत्ति सूची (Public Scholar's List):</strong> हम उन छात्रों का विवरण प्रदर्शित करते हैं जिन्हें ट्रस्ट द्वारा छात्रवृत्ति दी जाती है। इसमें छात्र का नाम, पिता का नाम, कक्षा और वितरित की गई सटीक छात्रवृत्ति राशि शामिल होती है। यह समाज को आश्वस्त करता है कि आपका पैसा सही और नेक काम (शिक्षा दान) में लग रहा है।</li>
            <li><strong>सार्वजनिक खर्च सूची (Public Expense List):</strong> संस्थागत खर्च (जैसे- वेतन, परीक्षा/कार्यक्रम का खर्च) पारदर्शी रूप से प्रदर्शित किए जाते हैं ताकि यह सुनिश्चित हो सके कि 10 करोड़ के स्थायी कोष (Corpus Fund) के नियमों का सख्ती से पालन किया जा रहा है।</li>
          </ul>

          <h4 className="privacy-policy-section-title">3. हम आपकी जानकारी का उपयोग कैसे करते हैं</h4>
          <p className="privacy-policy-paragraph">
            सार्वजनिक पारदर्शिता सूचियों के अलावा, आपके डेटा का उपयोग केवल ट्रस्ट के आंतरिक कार्यों के लिए किया जाता है:
          </p>
          <ul className="privacy-policy-list">
            <li>दान की रसीदें जारी करने और कानूनी लेखा-जोखा (Accounting) बनाए रखने के लिए।</li>
            <li>हमारी <strong>उच्च शिक्षा और माध्यमिक शिक्षा समितियों</strong> द्वारा योग्य छात्रों को छात्रवृत्ति और शिक्षा ऋण (Education Loan) के लिए पारदर्शी रूप से मूल्यांकन और चयन करने के लिए।</li>
            <li>'राजपूत प्रतिभा खोज परीक्षा' के आयोजन, संचार और प्रवेश पत्र/परिणाम जारी करने के लिए।</li>
          </ul>

          <h4 className="privacy-policy-section-title">4. डेटा सुरक्षा (Data Security)</h4>
          <p className="privacy-policy-paragraph">
            यद्यपि हम नाम और सहयोग राशि के लिए सार्वजनिक पारदर्शिता अपनाते हैं, लेकिन हम संवेदनशील आंतरिक डेटा (जैसे बैकएंड डेटाबेस एक्सेस, समितियों के आंतरिक मूल्यांकन नोट्स और सुरक्षित भुगतान प्रक्रिया) की पूरी सुरक्षा करते हैं। ट्रस्ट अपने ट्रस्टियों द्वारा अवैतनिक और स्वैच्छिक आधार पर संचालित किया जाता है, यह सुनिश्चित करते हुए कि किसी भी डेटा का व्यक्तिगत या व्यावसायिक लाभ के लिए उपयोग न हो। <strong>हम आपका व्यक्तिगत डेटा किसी भी बाहरी मार्केटिंग कंपनी को बेचते, किराए पर देते या साझा नहीं करते हैं।</strong>
          </p>

          <h4 className="privacy-policy-section-title">5. नीति में बदलाव</h4>
          <p className="privacy-policy-paragraph">
            राजपूत शिक्षा कोष की प्रबंध समिति (Trustee Board) के पास हमारी कार्यप्रणाली या कानूनी दायित्वों में होने वाले बदलावों के अनुसार आवश्यकता पड़ने पर इस गोपनीयता नीति को अपडेट करने का अधिकार सुरक्षित है।
          </p>

          <p className="privacy-policy-blessing">
            समाज को शिक्षित करने के हमारे इस पुनीत कार्य में एक पारदर्शी और महत्वपूर्ण भागीदार बनने के लिए आपका बहुत-बहुत धन्यवाद।
          </p>

          {/* --- SIGNATURE / CONTACT INFO --- */}
          <div className="privacy-policy-footer-sig">
            <h4>राजपूत शिक्षा कोष</h4>
            <p><strong>केंद्रीय कार्यालय:</strong> मारवाड़ राजपूत सभा भवन,<br/>पावटा 'बी' रोड, जोधपुर (राज.)</p>
            <p><strong>ईमेल:</strong> rajputshikshakosh@gmail.com</p>
            <p><strong>वेबसाइट:</strong> www.rajputshikshakosh.com</p>
          </div>
        </div>

      </div>
    </section>
    </>
  );
};

export default Privacy;